import React from 'react';
/*import tresc from '../assets/images/tre-sc2.png'*/
import tresc from '../assets/images/tre-sc3.png'
import rw3 from '../assets/images/1576000874853.jpg'
import mpsc from '../assets/images/MPSC_193x86.png'

const parceiros = (props) => {

    return (
        <div className="parceiros-container">
            <div className="bloco-dados w-full mb-0 flex-shrink-1">
                <div className="parceiros-logo">
                    <img className="parceiros-img" src={tresc}/>
                    <img className="parceiros-img" style={{ height: '5vh', minHeight: '45px'}} src={rw3}/>
                </div>                        
            </div>     
        </div>
    )
}

export default parceiros;    
